import { BaseApi } from './base.api.js';
import { UPLOAD_FILE_TIMEOUT_MS } from '@repo/contracts';
import { resolveOnUploadProgress, uploadAxiosConfig } from '../utils/upload-axios-config.js';

const isDebugEnabled = typeof import.meta !== 'undefined' && import.meta.env?.DEV;

export class AssessmentApi extends BaseApi {
    constructor(client) {
        super(client, '/assessment');
    }

    getAuditControls(id) {
        return this.client.get(`${this.basePath}/${id}/audit-controls`);
    }

    getEvaluation(id, params = {}) {
        return this.client.get(`${this.basePath}/${id}/evaluation`, { params });
    }

    submitDraft(id, data) {
        return this.client.post(`${this.basePath}/${id}/submit-draft`, data);
    }

    submitEvaluation(id, data) {
        return this.client.post(`${this.basePath}/${id}/submit`, data);
    }

    getAllEvaluations(id) {
        return this.client.get(`${this.basePath}/${id}/all-evaluations`);
    }

    getAllAuditControls(id) {
        return this.client.get(`${this.basePath}/${id}/all-audit-controls`);
    }

    uploadControlEvidence(assessmentId, controlId, file, optionsOrCallback) {
        const url = `${this.basePath}/${assessmentId}/control-evidence?controlId=${encodeURIComponent(controlId)}`;
        if (isDebugEnabled) {
            console.debug('[AssessmentApi] uploadControlEvidence request', {
                method: 'POST',
                url,
                assessmentId,
                controlId,
                fileName: file?.name,
                fileSize: file?.size,
                fileType: file?.type,
            });
        }
        const formData = new FormData();
        formData.append('file', file);
        return this.client.post(
            url,
            formData,
            uploadAxiosConfig({
                timeout: UPLOAD_FILE_TIMEOUT_MS,
                onUploadProgress: resolveOnUploadProgress(optionsOrCallback),
                headers: { 'Content-Type': 'multipart/form-data' },
            }),
        );
    }

    deleteControlEvidence(assessmentId, controlId, storedName) {
        const url = `${this.basePath}/${assessmentId}/control-evidence/${encodeURIComponent(controlId)}/${encodeURIComponent(storedName)}`;
        if (isDebugEnabled) {
            console.debug('[AssessmentApi] deleteControlEvidence request', {
                method: 'DELETE',
                url,
                assessmentId,
                controlId,
                storedName,
            });
        }
        return this.client.delete(
            url
        );
    }

    downloadControlEvidence(assessmentId, controlId, storedName) {
        const url = `${this.basePath}/${assessmentId}/control-evidence/${encodeURIComponent(controlId)}/${encodeURIComponent(storedName)}`;
        if (isDebugEnabled) {
            console.debug('[AssessmentApi] downloadControlEvidence request', {
                method: 'GET',
                url,
                assessmentId,
                controlId,
                storedName,
            });
        }
        return this.client.get(
            url,
            { responseType: 'blob' }
        );
    }
}
